import {  Component, Input, OnInit } from '@angular/core';
import { Device } from "../../../../model/device";

import {AuthGuard} from '../../../../common/auth-guard.service';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {CustomDatePipe} from "../../../../shared/pipes/custom-date.pipe";
import * as moment from "moment";

@Component({
  selector: 'app-device-diagnosis',
  templateUrl: './device-diagnosis.component.html',
  styleUrls: ['./device-diagnosis.component.scss']
})
export class DeviceDiagnosisComponent implements OnInit {

  @Input()
  public device: Device;


  public resultAvailable = false;
  public progress;
  public checkLogs: string;
  public analyzing = false;

  public results = [];
  public someErrors = false;

  constructor(private http: HttpClient,
              private router: Router,
              private customDatePipe: CustomDatePipe,
              public authGuard: AuthGuard) {}

  ngOnInit(): void {

    // this.layers = [{label: translate("nettopo.communications"), value: "communications"}, {label: translate("nettopo.distances"), value: "distances"},
    //   {label: translate("nettopo.coverage"), value: "coverage"}, {label: translate("nettopo.lastCommunication"), value: "lastCommunication"}]
    // this.categories= [ translate("nettopo.frames")];
    this.results["blocked"] = { ok:true, cause: "" };
    this.results["outdated"] = { ok:true, cause: ""};
    this.results["unmapped"] = { ok:true, cause: ""};
    this.results["invalid"] = { ok:true, cause: "" };
    this.results["unk_decoder"] = { ok:true, cause: "" };
    this.results["decoder"] = { ok:true, cause: "", message: "" };
  }

  start() {
    this.analyzing = true;
    this.progress = 0;
    this.checkBlockedDevice();
  }

  private checkBlockedDevice() {
    this.checkLogs = ("Comprobando configuraciones de integración...");
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.must.push({"match_phrase": {"resolvedUuid.keyword": {"query": this.device.uuid }}});
    this.http.post<any>(`/catalog/reports/blockeddevices`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["blocked"].ok = false;
        let bkdoc = res.hits.hits[0]._source;
        if(bkdoc.blockedByAsset) {
          this.results["blocked"].cause = "El dispositivo no tiene asset activo y no se han podido guardar los datos transmitidos el " + bkdoc["@timestamp"];
        } else {
          this.results["blocked"].cause = `El módulo de integración configurado es ${bkdoc.resolvedIntegrationIdentifier} (${bkdoc.resolvedIntegrationCode}) y debe ser ${bkdoc.requestedIntegrationIdentifier} (${bkdoc.requestedIntegrationCode})`;

        }
      }
      this.progress = 18;
      this.checkOutdatedMeasuresDevice();
    });
  }

  private checkOutdatedMeasuresDevice() {
    this.checkLogs = "Comprobando mediciones fuera de rango...";
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.filter.push({"match_phrase": {"level": "ERROR" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"process": "iotsens-knowledge-persistence" }});
    baseQuery.query.bool.filter.push({"bool": {"filter": [
          {"multi_match": {"type": "phrase","query": "com.iotsens.knowledge.persistence.exceptions.OutdatedMeasurementException","lenient": true}},
          {"multi_match": {"type": "phrase","query": this.device.uuid,"lenient": true}}
        ]}
    });
    this.http.post<any>(`/catalog/reports/tracing`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["outdated"].ok = false;
        this.results["outdated"].cause = JSON.parse(res.hits.hits[0]._source.message).measurements;
      }
      this.progress = 36;
      this.checkUnmapedMeasuresDevice();
    });
  }

  private checkUnmapedMeasuresDevice() {
    this.checkLogs = "Comprobando mediciones de sensores desconocidos...";
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.filter.push({"match_phrase": {"level": "ERROR" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"process": "iotsens-knowledge-persistence" }});
    baseQuery.query.bool.filter.push({"bool": {"filter": [
          {"multi_match": {"type": "phrase","query": "com.iotsens.knowledge.persistence.exceptions.UnknownMeasurementUUIDException","lenient": true}},
          {"multi_match": {"type": "phrase","query": this.device.uuid,"lenient": true }}]}
    });
    this.http.post<any>(`/catalog/reports/tracing`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["unmapped"].ok = false;
        this.results["unmapped"].cause = JSON.parse(res.hits.hits[0]._source.message).measurements;
      }
      this.progress = 52;
      this.checkInvallidMeasuresDevice();
    });
  }
  private checkInvallidMeasuresDevice() {
    this.checkLogs = "Comprobando mediciones no válidas...";
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.filter.push({"match_phrase": {"level": "ERROR" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"process": "iotsens-knowledge-persistence" }});
    baseQuery.query.bool.filter.push({"bool": {"filter": [
          {"multi_match": {"type": "phrase","query": "com.iotsens.knowledge.persistence.exceptions.InvalidMeasurementValueException","lenient": true}},
          {"multi_match": {"type": "phrase","query": this.device.uuid,"lenient": true }}]}
    });
    this.http.post<any>(`/catalog/reports/tracing`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["invalid"].ok = false;
        this.results["invalid"].cause = JSON.parse(res.hits.hits[0]._source.message).measurements;
      }
      this.progress = 70;
      this.checkDecoderDefinitionError();
    });
  }

  private checkDecoderDefinitionError() {
    this.checkLogs = "Comprobando definición del decodificador...";
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.filter.push({"match_phrase": {"level": "ERROR" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"process": "iotsens-ingestion-decoder" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"type": "blocked" }});
    baseQuery.query.bool.filter.push({"bool": {"filter": [
          {"multi_match": {"type": "phrase","query": "com.iotsens.ingestion.decoder.registry.exceptions.UnknownDecoderException","lenient": true}},
          {"multi_match": {"type": "phrase","query": this.device.uuid,"lenient": true }}]}
    });
    this.http.post<any>(`/catalog/reports/tracing`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["unk_decoder"].ok = false;
        let doc = res.hits.hits[0]._source;
        this.results["unk_decoder"].cause = doc.errorCause;
        this.results["unk_decoder"].message = JSON.stringify(doc);
      }
      this.progress = 88;
      this.checkDecoderErrorsDevice();
    });
  }

  private checkDecoderErrorsDevice() {
    this.checkLogs = "Comprobando errores de decodificación...";
    let baseQuery = this.getBaseQuery();
    baseQuery.query.bool.filter.push({"match_phrase": {"level": "ERROR" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"process": "iotsens-ingestion-decoder" }});
    baseQuery.query.bool.filter.push({"match_phrase": {"type": "decoding" }});
    baseQuery.query.bool.filter.push({"bool": {"filter": [
          {"multi_match": {"type": "phrase","query": this.device.uuid,"lenient": true }}]}
    });
    this.http.post<any>(`/catalog/reports/tracing`, baseQuery).toPromise().then( res => {
      if(res.hits.total.value > 0) {
        this.someErrors = true;
        this.results["decoder"].ok = false;
        let doc = res.hits.hits[0]._source;
        this.results["decoder"].cause = doc.errorCause;
        this.results["decoder"].message = JSON.stringify(doc);
      }
      this.progress = 100;
      this.resultAvailable = true;
    });
  }

  private getBaseQuery(): any {
    let baseQuery = {"size":  1, "query":{"bool":{"must":[],"filter":[],"should":[],"must_not":[]}}}
    baseQuery.query.bool.must.push({
      range: {
        "@timestamp": {
          format: "strict_date_optional_time",
          gte: moment.utc().subtract(7, "d").toDate(),
          lte: moment.utc().toDate()
        }
      }
    });
    return baseQuery;
  }
}
